import { createFileRoute } from '@tanstack/react-router';
import { Layout } from '~/components/layouts/layout';
import { m } from '~/paraglide/messages.js';
import { ApiKeysTable } from './-components/api-keys-table';
import { CreateApiKeyDrawer } from './-components/create-api-key-drawer';

export const Route = createFileRoute('/_authenticated/dev/')({
  component: DevPage,
});

function DevPage() {
  return (
    <Layout
      title={m['developer.menu.title']()}
      breadcrumbs={[{ label: m['developer.menu.title'](), href: '/dev' }]}
    >
      <div className="space-y-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight">
              {m['developer.api_keys.title']()}
            </h2>
            <p className="text-muted-foreground">
              {m['developer.api_keys.subtitle']()}
            </p>
          </div>
          <div className="sm:flex-shrink-0">
            <CreateApiKeyDrawer />
          </div>
        </div>

        <ApiKeysTable />
      </div>
    </Layout>
  );
}
